import productModule from './code/Scripts/Components/product-module.vue';
import DatalayerUpdate from './code/Scripts/Components/datalayer-update.vue';

export default {
  components: {
    productModule,
    DatalayerUpdate,
  },
};
